export default __webpack_public_path__ + "static/media/checked.1aa73887.svg";